<template>
  <div data-testid="deviceIdRule">
    <!-- eslint-disable vue/no-mutating-props -->
    <div class="form-group row">
      <form-label :is-required="true">
        <span>{{ capitalize(i18n.t('names.groupName', 1)) }}</span>
      </form-label>
      <div class="col-sm-8">
        <input
          id="edit_audience_rule_device_group_name"
          :value="name"
          data-testid="edit_audience_rule_device_group_name"
          name="groupName"
          :class="{
            'form-control': true,
            input: true,
            'is-danger': validator.messageBag.errors.has('groupName'),
          }"
          @change="(e) => emit('nameChanged', (e.target as HTMLInputElement).value)" />
        <span
          v-show="validator.messageBag.errors.has('groupName')"
          class="help is-danger"
          >{{ validator.messageBag.errors.first('demo') }}</span
        >
      </div>
    </div>

    <div class="form-group row">
      <form-label :is-required="true">
        <span>{{ capitalize(i18n.t('names.s3Path', 1)) }}</span>
      </form-label>
      <div class="col-sm-8">
        <input
          id="edit_audience_rule_device_group_s3path"
          :value="s3Path"
          data-testid="edit_audience_rule_device_group_s3path"
          name="s3Path"
          :class="{
            'form-control': true,
            input: true,
            'is-danger': validator.messageBag.errors.has(`S3Path_${audienceRule.key}`),
          }"
          @change="(e) => selectionChanged((e.target as HTMLInputElement).value)" />
        <span
          v-show="validator.messageBag.errors.has(`S3Path_${audienceRule.key}`)"
          class="help is-danger"
          >{{ validator.messageBag.errors.first(`S3Path_${audienceRule.key}`) }}</span
        >
      </div>
    </div>

    <!-- LOOKBACKWINDOW -->
    <edit-lookback-window
      :show-candidate-frequency="false"
      :audience-lookback-window="audienceRule.audienceLookbackWindow"
      :validator="validator" />
  </div>
</template>
<script setup lang="ts">
  import { capitalize } from 'vue';
  import { useI18n } from 'vue-i18n';

  import { FormLabel } from '@/common/components/controls';
  import AudienceRule from '@/common/models/audience/AudienceRule';
  import AudienceRuleCustomGroup from '@/common/models/audience/AudienceRuleCustomGroup';
  import Validator from '@/common/models/audience/Validator';
  import EditLookbackWindow from '@/org-app/components/audienceRules/edit/EditLookbackWindow.vue';

  // Setup
  const i18n = useI18n();
  const props = defineProps<{
    name: string;
    s3Path: string;
    deviceIDGroup: AudienceRuleCustomGroup;
    audienceRule: AudienceRule;
    validator: Validator;
  }>();
  const emit = defineEmits<{
    (e: 'nameChanged', name: string): void;
    (e: 'customGroupChanged', deviceIDGroup: AudienceRuleCustomGroup): void;
  }>();

  function selectionChanged(s3Path: string) {
    const deviceIDGroup = new AudienceRuleCustomGroup(props.name, s3Path);
    emit('customGroupChanged', deviceIDGroup);
  }
</script>
